<template>
  <v-container class="pa-6">
    <div style="margin-bottom: 24px">
      <div class="component-title">{{ profile.buyerName ? profile.buyerName : profile.phone }}</div>
      <v-breadcrumbs class="pa-0 ma-0" :items="items"
        ><template v-slot:divider class="pa-0">
          <v-icon>mdi-chevron-right</v-icon>
        </template>
      </v-breadcrumbs>
    </div>

    <LeadInfo :profile="profile" @refresh="refresh" :authorized="isUserAuthorized" />
    <LeadInCharge
      :profile="profile"
      :inCharge="users"
      :products="productsList"
      @refresh="refresh"
      :authorized="isUserAuthorized"
    />
    <v-card style="margin-bottom: 24px" outlined>
      <div class="d-flex justify-space-between align-items-center px-6 pt-6">
        <h5 class="text-uppercase align-self-center">Giai đoạn chăm sóc</h5>
      </div>
      <v-stepper v-model="currentStep" non-linear alt-labels class="stepper" elevation="0">
        <v-stepper-header>
          <v-stepper-step
            class="py-6 clickable-step"
            :complete="isStepComplete(1)"
            step="1"
            @click="handleStepClick(1)"
            :class="{ 'non-clickable-step': !isUserAuthorized }"
          >
            Chưa chăm sóc
          </v-stepper-step>
          <v-divider></v-divider>

          <v-stepper-step
            class="py-6 clickable-step"
            :complete="isStepComplete(2)"
            step="2"
            @click="handleStepClick(2)"
            :class="{ 'non-clickable-step': !isUserAuthorized }"
          >
            Đã đặt lịch hẹn
          </v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step
            class="py-6 clickable-step"
            :complete="isStepComplete(3)"
            step="3"
            @click="handleStepClick(3)"
            :class="{ 'non-clickable-step': !isUserAuthorized }"
          >
            Đã tư vấn trực tiếp
          </v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step
            class="py-6 clickable-step"
            :color="stepColor()"
            :complete="isStepComplete(4)"
            step="4"
            @click="handleStepClick(4)"
            :class="{ 'non-clickable-step': !isUserAuthorized }"
          >
            <v-menu v-model="showMenu" offset-y>
              <template v-slot:activator="{ on }">
                <div class="stepper-step-content" v-on="on" :style="stepStatusStyle">
                  <span v-if="profile.status === 'succeed'">Đã đăng ký xét tuyển</span>
                  <span v-else-if="profile.status === 'failed'">Thất bại</span>
                  <span v-else>Đã đăng kí tuyển sinh</span>
                </div>
              </template>

              <div class="button-background">
                <v-btn color="red" @click="setStatus('failed')" outlined small class="mr-1"> Thất bại </v-btn>
                <v-btn color="#008000" @click="setStatus('succeed')" bloked small class="white--text elevation-0">
                  Thành công
                </v-btn>
              </div>
            </v-menu>
          </v-stepper-step>
        </v-stepper-header>
      </v-stepper>
      <div class="px-6 pb-6">
        <span style="color: red">*</span>
        <span style="color: grey; font-size: smaller">
          Xin vui lòng bấm vào một bước trên để thay đổi giai đoạn chăm sóc</span
        >
      </div>
    </v-card>
    <LeadExtra :profile="profile" @refresh="refresh" :authorized="isUserAuthorized" />
    <v-card outlined>
      <div class="d-flex justify-space-between align-items-center px-6 py-6">
        <h5 class="text-uppercase align-self-center grey--text">Lịch sử chăm sóc</h5>
      </div>
      <LeadLog :items="sortedLogs" />
    </v-card>
    <div class="d-flex justify-center align-center mt-6" v-if="isUserAuthorized">
      <v-btn color="red" outlined @click="deleteDialog = true">Xóa khách hàng này</v-btn>
    </div>

    <LeadAppointment
      :dialog="showAppointment"
      @inputConfirmed="handleDate"
      @closeAppointment="showAppointment = false"
    />
    <LeadProduct
      :dialog="showProduct"
      :items="productsList"
      :profile="profile"
      :currItem="profile.product"
      @confirm="handleProduct"
      @closeProduct="showProduct = false"
    />
    <v-dialog v-model="deleteDialog" persistent max-width="420px">
      <v-card>
        <v-card-title class="headline">Xác nhận xóa khách hàng</v-card-title>
        <v-card-text> Bọn có chắc là bạn muốn xóa khách hàng này không? </v-card-text>
        <v-card-actions>
          <v-btn color="blue darken-4" text @click="deleteDialog = false" outlined>Hủy</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-4" class="white--text elevation-0" @click="deleteLead">Xác nhận</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import LeadAppointment from './LeadAppointment.vue'
import LeadProduct from './LeadProduct.vue'
import LeadLog from './LeadLog.vue'
import LeadInfo from './LeadInfo.vue'
import LeadInCharge from './LeadInCharge.vue'
import LeadExtra from './LeadExtra.vue'
export default {
  data() {
    return {
      profile: {},
      sortedLogs: [],
      showAppointment: false,
      showProduct: false,
      showMenu: false,
      deleteDialog: false,
      productsList: [],
      users: [],
      items: [
        {
          text: 'Danh sách khách hàng',
          disabled: false,
          href: '/lead',
        },
        {
          text: 'Thông tin cá nhân',
          disabled: false,
        },
      ],
    }
  },
  components: {
    LeadAppointment,
    LeadLog,
    LeadProduct,
    LeadInfo,
    LeadInCharge,
    LeadExtra,
  },
  mounted() {
    this.getProfileData()
    this.getLogs()
    this.getProducts()
    this.getUsers()
  },
  computed: {
    ...mapGetters('auth', ['user']),
    isUserAuthorized() {
      return (
        this.user.role.type === 'admin' ||
        !this.profile.inCharge ||
        !this.profile.inCharge.length > 0 ||
        this.profile.inCharge.some((inChargeUser) => inChargeUser.id === this.user.id)
      )
    },
    currentStep() {
      switch (this.profile.status) {
        case 'noContact':
          return 1
        case 'appointmentSet':
          return 2
        case 'productVerified':
          return 3
        case 'succeed':
        case 'failed':
          return 4
        default:
          return 0
      }
    },

    stepStatusStyle() {
      if (this.profile.status === 'succeed') {
        return { color: 'green' }
      } else if (this.profile.status === 'failed') {
        return { color: 'red' }
      } else {
        return {}
      }
    },
  },
  methods: {
    ...mapActions('lead', ['fetchLead', 'updateLead']),
    ...mapActions('leadLog', ['fetchLogs']),
    ...mapActions('appointment', ['createAppointment']),
    ...mapActions('product', ['fetchProducts']),
    ...mapActions('user', ['fetchUsers']),
    async getProfileData() {
      this.$loading.active = true
      const id = this.$route.params.id
      try {
        const response = await this.fetchLead(id)
        this.profile = response
      } catch (error) {
        console.error(error)
      } finally {
        this.$loading.active = false
      }
    },
    isStepComplete(stepNumber) {
      return this.currentStep > stepNumber
    },
    handleStepClick(step) {
      if (!this.isUserAuthorized) {
        this.$alert.error('Bạn không có quyền để thực hiện thao tác này')
        return
      }
      switch (step) {
        case 1:
          this.updateStatus('noContact')
          break
        case 2:
          this.openAppointment()
          break
        case 3:
          this.openProduct()
          break
        case 4:
          this.showMenu = !this.showMenu
          break
      }
    },
    async handleDate(data) {
      if (data.date !== '') {
        await this.updateStatus('appointmentSet')
        await this.createAppointment(data)
        this.showAppointment = false
      } else {
        await this.updateStatus('appointmentSet')
        this.showAppointment = false
      }
    },
    async handleProduct(data) {
      await this.updateLead({ id: this.profile.id, products: data })
      await this.updateStatus('productVerified')
      this.profile.product = data
      this.showProduct = false
    },
    async updateStatus(newStatus) {
      this.$loading.active = true
      try {
        const updatedLead = await this.updateLead({ id: this.profile.id, status: newStatus })
        if (updatedLead) {
          this.profile.status = updatedLead.status
        }

        this.$alert.success('Đã cập nhập trạng thái khách hàng thành công')
        this.getLogs()
      } catch (error) {
        console.error(error)
      } finally {
        this.$loading.active = false
      }
    },
    async getLogs() {
      const id = this.$route.params.id

      const logs = await this.fetchLogs({ lead: id })
      if (logs) {
        this.sortedLogs = logs.sort((a, b) => new Date(a.time) - new Date(b.time))
      }
    },
    async getProducts() {
      this.productsList = await this.fetchProducts()
    },
    async getUsers() {
      const users = await this.fetchUsers({ role_in: ['5d9227b2c887bb6b3283f776', '6569abe679c575d1488858f2'] })
      this.users = users
    },
    async deleteLead() {
      await this.updateLead({ id: this.profile.id, isArchived: 'true' })
      this.$alert.success('Xóa khách hàng thành công')
      this.deleteDialog = false
      this.$router.push('/lead')
    },
    refresh() {
      this.getProfileData()
      this.getLogs()
    },
    openAppointment() {
      this.showAppointment = true
    },
    openProduct() {
      this.showProduct = true
    },
    setStatus(newStatus) {
      this.updateStatus(newStatus)
      this.showMenu = false
    },
    stepColor() {
      switch (this.profile.status) {
        case 'succeed':
          return 'green'
        case 'failed':
          return 'red'
        default:
          return ''
      }
    },
  },
}
</script>

<style>
.stepper .v-stepper__label {
  text-align: center !important;
}

.clickable-step:hover {
  cursor: pointer;
}

.clickable-step:hover .v-stepper__label {
  color: #0d47a1 !important;
}

.button-background {
  background-color: #f5f5f5;
  padding: 10px;
  border-radius: 5px;
}
.return-btn {
  text-transform: lowercase !important;
  opacity: 1 !important;
}
.component-title {
  color: #0d47a1;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 28px;
}
.v-breadcrumbs__divider {
  padding: 0 !important;
}
.non-clickable-step {
  cursor: not-allowed !important;
}
</style>
